/*
 * Description  :
 * Date         :2021-11-01 14:02:38
 * LastEditors  :chenjia
 * LastEditTime :2021-12-23 16:16:37
 * FilePath     :\abackup-pay\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import ConfirmOrder from '../views/ConfirmOrder.vue'
import Pay from '../views/Pay.vue'
import RegistrationCode from '../views/RegistrationCode.vue'
import Invoice from '../views/Invoice.vue'
import Refund from '../views/Refund.vue'

Vue.use(VueRouter)

const routes = [{
  path: '*', component: ConfirmOrder
  },
  {
    path: '/',
    name: 'ConfirmOrder',
    component: ConfirmOrder
  },
  {
    path: '/pay',
    name: 'Pay',
    component: Pay
  },
  {
    path: '/registrationCode',
    name: 'RegistrationCode',
    component: RegistrationCode
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: Invoice
  },
  {
    path: '/refund',
    name: 'Refund',
    component: Refund
  }

]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router